import { Grid, Layout } from 'antd';
import Footer from 'components/Footer';
import HeaderNav from 'components/HeaderNav';
import MobileNav from 'components/MobileNav';
import PageHeader from 'components/PageHeader';
import SideNav from 'components/SideNav';
import TopNav from 'components/TopNav';
import { FIRM_ID } from 'constants/StorageConstant';
import { DIR_LTR, DIR_RTL, NAV_TYPE_SIDE, NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import helperFunc from 'helpers/helperFunc';
import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import tools from 'tools';
import { selectActivityStatusList } from 'utils/redux/actions/activityStatusActions';
import { appListener } from 'utils/redux/actions/appListenerActions';
import { selectHomePageNotificationList, selectUnreadNotificationCount } from 'utils/redux/actions/notiificationActions';
import { selectChatList } from 'utils/redux/actions/chatActions';
import * as signalR from '@microsoft/signalr';
import { API_BASE_URL } from 'constants/ApiConstant';
import globalConstant from 'constants/globalConstant';
import { chatTrace, ensureChatTraceId, registerChatTraceBridge, resolveChatCustomerNumber } from 'utils/chatTrace';

function formatMockMessageDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

function formatMockMessageTime(date) {
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  return `${hour}:${minute}`;
}

function buildMockChatReceivedEvent({
  listenerType,
  customerNumber,
  customerName,
  text,
  sendType,
}) {
  const now = new Date();
  const messageDate = formatMockMessageDate(now);
  const messageTime = formatMockMessageTime(now);
  const resolvedListenerType = listenerType || globalConstant.listenerTypes.inboundmessage;
  const resolvedSendType = sendType || (resolvedListenerType === globalConstant.listenerTypes.outboundmessage ? 2 : 1);
  const isInbound = resolvedSendType === 1;
  const resolvedCustomerNumber = customerNumber || '905550000000';
  const resolvedCustomerName = customerName || 'Local Test Customer';

  const payload = {
    mainMessageId: `mock-${Date.now()}-${Math.floor(Math.random() * 10000)}`,
    source: isInbound ? resolvedCustomerNumber : 'firm-local',
    destination: isInbound ? 'firm-local' : resolvedCustomerNumber,
    customerNumber: resolvedCustomerNumber,
    sourcePhone: resolvedCustomerNumber,
    customerName: resolvedCustomerName,
    sendType: resolvedSendType,
    messageDate,
    messageTime,
    isOpenTransaction: true,
    isOpenAdmin: !isInbound,
    isAdminTransaction: !isInbound,
    activityId: 0,
    activityName: '',
    message: {
      type: 'text',
      text: text || `Local mock message (${resolvedSendType === 1 ? 'inbound' : 'outbound'})`
    }
  };

  return {
    type: resolvedListenerType,
    payload: JSON.stringify(payload)
  };
}


function AppLayout({ navCollapsed, navType, direction, appListenerAction
  , selectActivityStatusListAction, selectHomePageNotificationListActions, selectUnreadNotificationCountActions, selectChatListAction,selectChatListDetailAction }) {
  const { Content } = Layout;
  const { useBreakpoint } = Grid;
  navType = "SIDE";
  direction = DIR_LTR;
  const navigationConfig = helperFunc.getLeftMenuList();
  const currentRouteInfo = tools.getRouteInfo(navigationConfig, "/")

  const [currentRoute, setCurrentRoute] = useState(currentRouteInfo);
  const screens = tools.getBreakPoint(useBreakpoint());
  const [selectedApp, setSelectedApp] = useState("");

  const isMobile = screens.length === 0 ? false : !screens.includes('lg')
  const isNavSide = navType === NAV_TYPE_SIDE
  const isNavTop = navType === NAV_TYPE_TOP
  const firmId = localStorage.getItem(FIRM_ID);
  const firmAdminState = JSON.parse(localStorage.getItem('isFirmAdmin'));
  const signalRConnectionRef = useRef(null);
  const isConnectListener = useRef(false);
  const notificationAudioRef = useRef(null);


  const navigate = useNavigate();

  useEffect(() => {
    registerChatTraceBridge();
  }, []);


  const handleChangeApp = (value, menuListData) => {
    setSelectedApp(value);
    const selectedApp = menuListData.find((app) => app.appName === value);
    if (selectedApp) {
      localStorage.setItem('selectedApp', JSON.stringify(selectedApp));
    }
  };

  useEffect(() => {
    const storedSelectedApp = JSON.parse(localStorage.getItem('selectedApp'));
    if (storedSelectedApp != null) {

      setSelectedApp(storedSelectedApp.appName);
    }
  }, []);



  useEffect(() => {
    if (!firmAdminState) {
      navigate('/barista-screen');
    }
    if (!firmAdminState && firmId == 5) {
      navigate('/kodsan-report');
    }
  }, [firmAdminState, navigate]);

  useEffect(() => {
    if (isConnectListener.current == false) {
      const hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${API_BASE_URL}/messagehub`, {})
        .build();


      signalRConnectionRef.current = hubConnection;

      hubConnection.on('whatsappListener_' + firmId, onOrderReceived);


      function startConnection() {
        hubConnection.start().catch(err => { reconnect(); }).then(response => {

          isConnectListener.current = true;
        });
      }
      startConnection();

      function reconnect() {

        setTimeout(startConnection, 2000);
      }

      hubConnection.onclose(reconnect);
    }

  }, []);

  // useEffect(() => {

  //   const hubUpdateConnection = new signalR.HubConnectionBuilder()
  //     .withUrl(`${API_BASE_URL}/updatehub`, {}).build();




  //   function startConnection() {
  //     hubUpdateConnection.start().catch(err => { reconnect(); }).then(response => {

  //       hubUpdateConnection.on('ReceiveUpdate', () => {

  //         window.location.reload();
  //       });
  //       isConnectListener.current = true;
  //     });
  //   }
  //   startConnection();

  //   function reconnect() {

  //     setTimeout(startConnection, 2000);
  //   }

  //   hubUpdateConnection.onclose(reconnect);
  // }, [])
  const onOrderReceived = (data) => {
    let receivedEvent = data;
    let traceId = "";
    let customerNumber = "";

    try {
      const payload = data?.payload ? JSON.parse(data.payload) : null;
      if (payload && typeof payload === 'object') {
        customerNumber = resolveChatCustomerNumber(payload);
        traceId = ensureChatTraceId(payload, customerNumber);
        receivedEvent = {
          ...data,
          payload: JSON.stringify(payload)
        };
      }
    } catch (error) {
      chatTrace('signalr.message.parseFailed', {
        listenerType: data?.type,
        error: error?.message || error
      }, 'warn');
    }

    chatTrace('signalr.message.received', {
      traceId,
      listenerType: receivedEvent?.type,
      customerNumber,
      hasPayload: !!receivedEvent?.payload
    });

    appListenerAction(receivedEvent);
    var listenerType = receivedEvent.type;
    if (listenerType == globalConstant.listenerTypes.neworder || listenerType == globalConstant.listenerTypes.newcustomer) {
      selectHomePageNotificationListActions();
      selectUnreadNotificationCountActions();
    }
    if (listenerType == globalConstant.listenerTypes.connectCustomerService) {
      if (notificationAudioRef.current) {
        notificationAudioRef.current.currentTime = 0;
        notificationAudioRef.current.play();
      }
      selectChatListAction();
    }
  }

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      return;
    }

    if (typeof window === 'undefined') {
      return;
    }

    const mockBridge = {
      emit: (received) => {
        onOrderReceived(received);
        return received;
      },
      inbound: (options = {}) => {
        const received = buildMockChatReceivedEvent({
          ...options,
          listenerType: globalConstant.listenerTypes.inboundmessage,
          sendType: 1
        });
        onOrderReceived(received);
        return received;
      },
      outbound: (options = {}) => {
        const received = buildMockChatReceivedEvent({
          ...options,
          listenerType: globalConstant.listenerTypes.outboundmessage,
          sendType: 2
        });
        onOrderReceived(received);
        return received;
      },
      connectCustomerService: (options = {}) => {
        const resolvedCustomerNumber = options.customerNumber || '905550000000';
        const resolvedCustomerName = options.customerName || 'Local Test Customer';
        const received = {
          type: globalConstant.listenerTypes.connectCustomerService,
          payload: JSON.stringify({
            sourcePhone: resolvedCustomerNumber,
            customerNumber: resolvedCustomerNumber,
            customername: resolvedCustomerName
          })
        };
        onOrderReceived(received);
        return received;
      },
      help: () => {
      }
    };

    window.chatshireMock = mockBridge;
    console.info('[chatshireMock] Ready. Run window.chatshireMock.help() in browser console.');

    return () => {
      if (window.chatshireMock === mockBridge) {
        delete window.chatshireMock;
      }
    };
  }, []);


  useEffect(() => {
    selectActivityStatusListAction();
  }, []);

  const getLayoutDirectionGutter = () => {
    if (direction === DIR_LTR) {
      return { paddingLeft: getLayoutGutter(), minWidth: "100%" }
    }
    if (direction === DIR_RTL) {
      return { paddingRight: getLayoutGutter(), minWidth: "100%" }
    }
    return { paddingLeft: getLayoutGutter(), minWidth: "100%" }
  }

  const getLayoutGutter = () => {
    if (isNavTop || isMobile) {
      return 0
    }
    return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH
  }
  return (
    <>
      <audio ref={notificationAudioRef} src="/notification.mp3" preload="auto" />
      <HeaderNav isMobile={isMobile} selectedApp={selectedApp} />
      {(isNavTop && !isMobile) ? <TopNav routeInfo={currentRoute} /> : null}
      {(!firmAdminState) ?
        <Layout className="app-container ">
          <Content className='mt-3'>
            <Outlet />
          </Content>
        </Layout> :
        <Layout className="app-container">
          {(isNavSide && !isMobile) ? <SideNav routeInfo={currentRoute} handleChange={handleChangeApp}
            selectedValue={selectedApp} /> : null}
          <Layout className="app-layout" style={getLayoutDirectionGutter()}>
            <div className={`app-content pt-2 ${isNavTop ? 'layout-top-nav' : ''}`}>
              <PageHeader display={currentRoute?.breadcrumb} title={currentRoute?.title} />
              <Content>
                <Outlet />
              </Content>
            </div>
            <Footer />
          </Layout>
        </Layout>}


      {isMobile && <MobileNav />}
    </>

  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, locale } = theme;

  return { navCollapsed, navType, locale, }
};
function mapDispatchToProps(dispatch) {
  return {
    appListenerAction: bindActionCreators(appListener, dispatch),
    selectHomePageNotificationListActions: bindActionCreators(selectHomePageNotificationList, dispatch),
    selectUnreadNotificationCountActions: bindActionCreators(selectUnreadNotificationCount, dispatch),
    selectActivityStatusListAction: bindActionCreators(selectActivityStatusList, dispatch),
    selectChatListAction: bindActionCreators(selectChatList, dispatch),
    selectChatListDetailAction:bindActionCreators(selectChatList, dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(AppLayout));
// export default AppLayout;
